import React from 'react';

import { type Prize } from '@app/client/common/structs';

import { Wrapper } from './styles';

interface AssignWinnerPrizeItemProps {
    prize: Prize;
}
export const AssignWinnerPrizeItem = ({ prize }: AssignWinnerPrizeItemProps) => {
    // TODO find out from BE if we'll be able to assign prizes with no winner as there's no winner id to use
    return (
        <Wrapper>
            <div>
                <span>
                    <strong>#{prize.rank}</strong> {prize.name}
                </span>
                <br />
                <strong>{prize.reward}</strong>
            </div>
        </Wrapper>
    );
};
